import { get } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";

export interface Pais {
  id: string;
  nombre: string;
  departamentos: Array<Departamento>;
}

export interface Departamento {
  id: string;
  nombre: string;
  ciudades: Array<Ciudad>;
}

export interface Ciudad {
  id: string;
  nombre: string;
  sectores: Array<Sector>;
}

export interface Sector {
  id: string;
  nombre: string;
}

export interface PaisResumido {
  id: string;
  nombre: string;
}

export interface DepartamentoResumido {
  id: string;
  nombre: string;
}

export interface CiudadResumida {
  id: string;
  nombre: string;
}

export const leerPaises = async (): Promise<Array<Pais> | undefined> => {
  return get<Array<Pais> | undefined>("paises");
};

export const QUERY_KEY_LEER_SECTORES_ORIGEN = "leer_sectores_origen";

export const useLeerSectoresOrigen = () =>
  useQuery(
    [QUERY_KEY_LEER_SECTORES_ORIGEN],
    async () => await leerSectoresOrigen()
  );

export const leerSectoresOrigen = async (): Promise<
  Array<Sector> | undefined
> => {
  return get<Array<Sector> | undefined>("sectores/origen");
};

export interface CiudadResumida {
  id: string;
  nombre: string;
}

export const leerCiudadOrigen = async (): Promise<
  CiudadResumida | undefined
> => {
  return get<CiudadResumida | undefined>("ciudades/origen");
};

export const QUERY_KEY_LEER_CIUDAD_ORIGEN = "leer_ciudad_origen";

export const useLeerCiudadOrigen = () =>
  useQuery(
    [QUERY_KEY_LEER_CIUDAD_ORIGEN],
    async () => await leerCiudadOrigen()
  );
